<template>
  <div ref="moduleItem" class="inner"
    :data-mods="itemData.mods"
    :data-sticky="itemSetting.layout.sticky"
    :style="setBasicStyle">
    <div v-if="itemSetting.layout.background.value !== '' && itemSetting.layout.background.overlay"
      class="moduleInner"
      :style="{backgroundColor: itemSetting.layout.background.color}" />
      <SetLink v-if="typeof (itemSetting.layout.link) !== 'undefined' && itemSetting.layout.link.active"
        :linkTarget="itemSetting.layout.link"
        :lang="lang" />
      <div v-if="itemData.extra && typeof (itemData.extra) !== 'undefined'"
        :data-max_width="itemSetting.layout.activeMaxWidth && itemSetting.layout.maxWidth ? itemSetting.layout.maxWidth : null"
        class="module"
        :style="{maxWidth: getMaxWidth}">
        <!-- datetime -->
        <Datetime v-if="itemData.mods === 'datetime'"
          :id="data.id"
          :locale="locale"
          :itemData="itemData"
          :itemSetting="itemSetting"
          :lang="lang"
          @setPopover="setPopover">
        </Datetime>
        <!-- //datetime -->
        <!-- smartkey -->
        <div v-if="itemData.mods === 'smartkey'" class="formGroup">
          <Smartkey
            :locale="locale"
            :itemData="itemData" />
        </div>
        <!-- //smartkey -->
      </div>
      <div v-else class="module"
        :data-column_padding_lr="itemSetting.layout.columns && itemSetting.layout.columns.padding.lr"
        :data-max_width="itemSetting.layout.activeMaxWidth && itemSetting.layout.maxWidth ? itemSetting.layout.maxWidth : null"
        :style="moduleStyle(itemSetting.layout.flex || itemSetting.layout.columns)">
        <div class="column setbox"
          v-for="(item, idx) in itemData.column"
          :key="idx"
          :class="{columnBreak: item.type === 'break'}"
          :style="columnStyle(item)">
          <SetLink v-if="item.detail && item.detail.link && item.detail.link.active !== false" class="columnLink"
            :linkTarget="item.detail.link"
            :lang="lang" />
          <!-- division -->
          <div v-if="item.type === 'division'" class="division">
            <div class="line" :style="setDivisionStyle(item)"></div>
          </div>
          <!-- //division -->
          <!-- break column -->
          <div v-if="item.type === 'break'" class="break" :style="{height: `${Number(item.height) * 15}px`}"></div>
          <!-- //break column -->
          <!-- text -->
          <div v-if="item.type === 'text'" v-html="item.value[lang]" class="standardText" :class="{hide: item.detail && item.detail.upload && item.detail.upload.active ? !uploadFileActive(item.detail.upload) : false}"></div>
          <!-- //text -->
          <!-- image -->
          <div v-if="item.type === 'image'" class="standardImage imgFrame" :style="imgStyle(item.detail)" :class="{hide: item.detail && item.detail.upload && item.detail.upload.active ? !uploadFileActive(item.detail.upload) : false}">
            <img v-lazyload :data-src="item.value" alt="" />
            <div v-if="item.value !== null" class="dimmer" :style="{backgroundColor: item.dimmer}"></div>
            <button v-if="item.enlarge" type="button" class="btnImageViewer" @click="imgView($event, item.value)"><span class="blind">show image viewer</span></button>
          </div>
          <!-- //image -->
          <!-- embed -->
          <Embed v-if="item.type === 'embed'" class="standardEmbed formGroup"
            :locale="locale"
            :value="item.value" />
          <!-- //embed -->
          <!-- instagramfeed -->
          <div v-if="item.type === 'instagramfeed' && instagramActive">
            <Instagramfeed
              :locale="locale"
              :setting="item.detail" />
          </div>
          <!-- //instagramfeed -->
          <!-- qrcode -->
          <div v-if="item.type === 'qrcode'" class="standardQrcode formGroup">
            <Qrcode
              :locale="locale"
              :setting="item.detail"
              :qrcode="fullUrl(item.detail.qrcode, item.detail.qrcodeExpired)"
              :isString="isStringCode(item.detail.qrcode)"
              :publicOta="publicOta" />
          </div>
          <!-- //qrcode -->
          <!-- smartvoice -->
          <div v-if="item.type === 'smartvoice'" class="standardSmartvoice formGroup">
            <SmartVoice
              :locale="locale"
              :id="data.id"
              :setting="item.detail"
              @setPopover="setPopover" />
          </div>
          <!-- //smartvoice -->
          <!-- clock -->
          <Clock v-if="item.type === 'clock'"
           :item="item" />
          <!-- //clock -->
          <!-- carousel -->
          <Gallery v-if="item.type === 'carousel'"
            :id="data.id"
            :item="item.value"
            :option="typeof (item.detail) !== 'undefined' ? item.detail.carousel : {}"
            :detailData="item.detail"
            :lang="lang" />
          <!-- //carousel -->
          <!-- signaturepad -->
          <Signaturepad v-if="item.type === 'signaturepad'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
             />
          <!-- //signaturepad -->
          <!-- certification -->
          <Cert v-if="item.type === 'cert'"
            :id="data.id"
            :item="item"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
             />
          <!-- //certification -->
          <!-- postcode -->
          <Postcode v-if="item.type === 'postcode'"
            :id="data.id"
            :item="item"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
            @setPopover="setPopover"
             />
          <!-- //postcode -->
          <!-- input -->
          <Input v-if="item.type === 'input'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
             />
          <!-- //input -->
          <!-- textarea -->
          <Textarea v-if="item.type === 'textarea'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
             />
          <!-- //textarea -->
          <!-- rate -->
          <Rate v-if="item.type === 'rate'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
             />
          <!-- //rate -->
          <!-- radio -->
          <Radio v-if="item.type === 'radio'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
            :subOption="subOption"
             />
          <!-- //radio -->
          <!-- checkbox -->
          <Checkbox v-if="item.type === 'checkbox'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
            :subOption="subOption"
             />
          <!-- //checkbox -->
          <!-- select -->
          <Select v-if="item.type === 'select'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
            :subOption="subOption"
            :hiddenPrice="hiddenPrice"
             />
          <!-- //select -->
          <!-- quantity -->
          <Quantity v-if="item.type === 'quantity'"
            :id="data.id"
            :itemSetting="itemSetting"
            :currency="currency"
             />
          <!-- //quantity -->
          <!-- button -->
          <div v-if="item.type === 'button'" class="formGroup">
            <div v-if="item.detail.button.type === 'link'"
              :style="setDetailStyle(item.detail)"
              class="btn btnFull">
              <div v-html="item.value[lang]"></div>
              <SetLink
                :linkTarget="item.detail.button.link"
                :lang="lang" />
            </div>
            <Submit v-else-if="item.detail.button.type === 'submit'"
              :pageId="pageId"
              :id="data.id"
              :item="item"
              :lang="lang"
              :locale="locale"
              :currency="currency"
              :detailStyle="setDetailStyle(item.detail)"
              :pageGuestType="pageGuestType"
              :isFolioInfo="isFolioInfo"
              :disabledSubmit="disabledSubmit"
              :usableCoupon="usableCoupon"
              @updateUsableCoupon="updateUsableCoupon"
              @summaryOn="summaryOn"
              @setPopover="setPopover" />
          </div>
          <!-- //button -->
          <!-- calendar -->
          <Calendar v-if="item.type === 'calendar'"
            :id="data.id"
            :itemSetting="itemSetting"
            :lang="lang"
            :locale="locale"
            @setPopover="setPopover" />
          <!-- //calendar -->
          <!-- upload file -->
          <Upload v-if="item.detail && item.detail.upload && item.detail.upload.active && item.detail.upload.files.length"
            :id="data.id"
            :columnId="item.columnId"
            :locale="locale"
            :lang="lang"
            :detailData="item.detail.upload" />
          <!-- //upload file -->
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import SetLink from '@/components/Util/SetLink.vue'
import Signaturepad from './ModuleItem/Signaturepad.vue'
import Cert from './ModuleItem/Cert.vue'
import Postcode from './ModuleItem/Postcode.vue'
import Input from './ModuleItem/Input.vue'
import Textarea from './ModuleItem/Textarea.vue'
import Rate from './ModuleItem/Rate.vue'
import Radio from './ModuleItem/Radio.vue'
import Checkbox from './ModuleItem/Checkbox.vue'
import Select from './ModuleItem/Select.vue'
import Quantity from './ModuleItem/Quantity.vue'
import Submit from './ModuleItem/Submit.vue'
import Datetime from './ModuleItem/Datetime.vue'
import Gallery from './ModuleItem/Gallery.vue'
import Calendar from './ModuleItem/Calendar.vue'
import Clock from './ModuleItem/Clock.vue'
import Qrcode from './ModuleItem/Qrcode.vue'
import Smartkey from './ModuleItem/Smartkey.vue'
import SmartVoice from './ModuleItem/SmartVoice.vue'
import Upload from './ModuleItem/Upload.vue'
import Instagramfeed from './ModuleItem/Instagramfeed.vue'
import Embed from './ModuleItem/Embed.vue'

export default {
  name: 'Module',
  props: [
    'lang',
    'pageId',
    'data',
    'locale',
    'mId',
    'subOption',
    'pageGuestType',
    'isFolioInfo',
    'disabledSubmit',
    'usableCoupon',
    'hiddenPrice'
  ],
  components: {
    SetLink,
    Signaturepad,
    Cert,
    Postcode,
    Input,
    Textarea,
    Rate,
    Radio,
    Checkbox,
    Select,
    Quantity,
    Submit,
    Datetime,
    Gallery,
    Calendar,
    Clock,
    Qrcode,
    Smartkey,
    SmartVoice,
    Upload,
    Instagramfeed,
    Embed
  },
  computed: {
    ...mapGetters({
      link: 'util/setLink'
    }),
    setting () {
      return this.$store.state.common.setting
    },
    instagramActive () {
      const thirdparty = this.$store.getters['thirdparty/getThirdparty']
      const instagramfeed = thirdparty && thirdparty.find(x => x.id === 'instagramfeed')
      return instagramfeed ? instagramfeed.active : null
    },
    siteinfo () {
      return this.$store.state.authentication
    },
    currency () {
      return {
        c: this.setting.currency,
        e: this.setting.currencyEntity
      }
    },
    dateFormat () {
      return this.setting.dateformatFormat
    },
    itemData () {
      return this.data.dataSet
    },
    itemSetting () {
      return this.data.setting
    },
    setBasicStyle () {
      const layoutData = this.itemSetting.layout
      const notStyles = ['options', 'link', 'division']
      const styles = Object.keys(layoutData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = layoutData[x]
        let filters = 'active'
        if (typeof (obj.active) !== 'undefined' && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'link':
              break
            case 'background':
              filters = 'active' || 'value'
              styleObj['background-image'] = `url(${obj.value})`
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                if (o !== filters) {
                  styleObj[key] = value
                }
              })
              break
            case 'border':
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                if (o !== filters) {
                  styleObj[key] = value
                }
              })
              break
            case 'radius':
              styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
              break
            case 'padding':
              styleObj['padding-top'] = `${obj.tb}px`
              styleObj['padding-bottom'] = `${obj.tb}px`
              styleObj['padding-left'] = `${obj.lr}px`
              styleObj['padding-right'] = `${obj.lr}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
      })
      return styleObj
    },
    getMaxWidth () {
      const layout = this.itemSetting.layout
      const isActive = layout.activeMaxWidth
      const maxWidth = isActive
        ? layout.maxWidth === 'input'
          ? layout.maxWidthInput ? `${layout.maxWidthInput}px` : '100%'
          : `${layout.maxWidth}%`
        : null
      return maxWidth
    },
    getColumnMinWidth () {
      const layout = this.itemSetting.layout
      const isActive = layout.columns && layout.columns.minWidth && parseInt(layout.columns.minWidth)
      const minWidth = isActive ? `${layout.columns.minWidth}px` : null
      return minWidth
    },
    getColumnAlignStyle () {
      const layout = this.itemSetting.layout
      const columns = layout && layout.columns
      const container = columns && columns.stretch ? 'stretch' : columns && columns.alignItems
      const item = container === 'stretch' ? columns.alignItems : null
      return {
        container: container,
        item: item
      }
    }
  },
  watch: {
  },
  mounted () {
    setTimeout(() => {
      this.setSubmitData()
    }, 500)
    if (this.siteinfo && this.siteinfo.public === 'true' && this.siteinfo.k) {
      this.publicOta = this.siteinfo.k
    }
  },
  data () {
    return {
      publicOta: null,
      storageSubmitData: null
    }
  },
  methods: {
    updateUsableCoupon (couponList) {
      this.$emit('updateUsableCoupon', couponList)
    },
    imgView (e, src) {
      e.stopPropagation()
      this.$store.commit('setImgSrc', src)
    },
    setLink (target) {
      return this.link(target)
    },
    moduleStyle (style) {
      let result = {}
      if (this.getMaxWidth) {
        result = {
          ...result,
          maxWidth: this.getMaxWidth
        }
      }
      if (this.getColumnMinWidth) {
        result = {
          ...result,
          overflow: 'auto',
          flexWrap: 'nowrap',
          justifyContent: 'flex-start',
          minWidth: '100%',
          maxWidth: 'none'
        }
      }
      if (style) {
        result = {
          ...result,
          alignItems: this.getColumnAlignStyle && this.getColumnAlignStyle.container,
          ...style.padding && style.padding.lr === '0' && style.padding.lr === '0' && {
            margin: 0
          }
        }
      }
      return result
    },
    columnStyle (column) {
      const layoutData = column.flex ? { ...column.detail, flex: column.flex } : column.detail
      const notStyles = ['link']
      const styles = layoutData ? Object.keys(layoutData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      }) : []
      const styleObj = {}
      const noColumnType = !(column.type.includes('division') || column.type.includes('button') || column.type.includes('image') || column.type.includes('carousel'))
      const getColumnMinWidth = this.getColumnMinWidth
      const columnAlignItems = this.getColumnAlignStyle && this.getColumnAlignStyle.item
      styles.forEach(function (x) {
        const obj = layoutData[x]
        let filters = 'active'
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'link':
              break
            case 'background':
              if (noColumnType) {
                filters = 'active' || 'dataId' || 'src' || 'value'
                styleObj['background-image'] = `url(${obj.value})`
                Object.keys(obj).forEach(function (o) {
                  key = `${x}-${o}`
                  value = obj[o]
                  if (o !== filters) {
                    if (o === 'value') {
                      styleObj[key] = value
                    }
                    styleObj[key] = value
                  }
                })
              }
              break
            case 'border':
              if (noColumnType) {
                styleObj['border-width'] = '1px'
                Object.keys(obj).forEach(function (o) {
                  key = `${x}-${o}`
                  value = obj[o]
                  if (o !== filters) {
                    styleObj[key] = value
                  }
                })
              }
              break
            case 'radius':
              if (noColumnType) {
                styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.bl}px ${obj.br}px`
              }
              break
            case 'padding':
              styleObj['padding-top'] = `${obj.tb}px`
              styleObj['padding-bottom'] = `${obj.tb}px`
              styleObj['padding-left'] = `${obj.lr}px`
              styleObj['padding-right'] = `${obj.lr}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
      })
      if (layoutData && layoutData.flex) {
        styleObj.flex = layoutData.flex
      }
      if (getColumnMinWidth) {
        styleObj.minWidth = getColumnMinWidth
        styleObj.flex = 'none'
        styleObj.width = 'auto'
      }
      if (columnAlignItems) {
        styleObj.display = 'flex'
        styleObj.flexDirection = 'column'
        styleObj.justifyContent = columnAlignItems
      }
      return styleObj
    },
    imgStyle (data) {
      const detail = data || null
      const border = detail && detail.border && detail.border.active ? detail.border : null
      const background = detail && detail.background && detail.background.active ? detail.background : null
      const bgImg = background && background.value ? `url(${background.value}) ${background.position} / ${background.size} ${background.repeat}` : ''
      const radius = detail && detail.radius && detail.radius.active ? detail.radius : null
      const borderRadius = radius ? `${radius.tl}px ${radius.tr}px ${radius.br}px ${radius.bl}px` : null
      return {
        ...border && {
          border: `1px ${border.style} ${border.color}`
        },
        'border-radius': borderRadius,
        ...background && {
          background: `${background.color} ${bgImg}`
        }
      }
    },
    setSubmitData () {
      if (this.data.setting.action !== null && !this.data.hide) {
        const data = this.data.setting.action
        const lang = this.lang
        let value
        let passed = data.isRequired ? false : null
        const storage = this.storageSubmitData
        switch (data.name) {
          case 'rate':
            value = {
              max: data.max,
              value: data.rateValue || data.max
            }
            passed = true
            break
          case 'radio':
            // 기본선택 옵션이 현재 있는 옵션과 싱크가 맞는지?
            const getDefaultValue = data.item && data.item.map((x, i) => {
              const id = x.id || `${i}_${x.value}`
              return {
                ...x,
                id: id
              }
            }).find((x) => {
              return data.defaultValue === x.id
            })
            data.defaultValue = getDefaultValue ? getDefaultValue.id : ''
            value = data.hasDefault ? data.defaultValue : ''
            if (data.isRequired && data.hasDefault === true && !!data.defaultValue) {
              passed = true
            }
            if (data.hasDefault && data.defaultValue && data.item.find(x => x.price)) {
              const index = value.split('_')[0]
              const optionData = {
                id: this.data.id,
                label: data.item[index].label[lang],
                price: Number(data.item[index].price),
                ...data.optionQuantity && {
                  quantity: Number(data.item[index].quantity)
                },
                ...data.item[index].invisible && {
                  invisible: data.item[index].invisible
                }
              }
              this.$store.commit('page/priceOption', optionData)
            }
            break
          case 'checkbox':
            // 기본선택 옵션이 현재 있는 옵션과 싱크가 맞는지?
            data.defaultValue = data.defaultValue && data.defaultValue.filter(v => {
              return data.item.map((x, i) => x.id || `${i}_${x.value}`).find(x => x === v)
            }) || []
            value = data.hasDefault ? data.defaultValue : []
            if (data.isRequired && data.hasDefault === true && !!data.defaultValue) {
              passed = true
            }
            if (data.hasDefault && data.defaultValue.length && data.item.find(x => x.price)) {
              const id = this.data.id
              const index = value.map(x => x.split('_')[0])
              const Store = this.$store
              index.forEach(function (i) {
                const optionData = {
                  id: `${id}_${i}`,
                  label: data.item[i].label[lang],
                  price: Number(data.item[i].price),
                  ...data.optionQuantity && {
                    quantity: Number(data.item[i].quantity)
                  },
                  ...data.item[i].invisible && {
                    invisible: data.item[i].invisible
                  }
                }
                Store.commit('page/priceOption', optionData)
              })
            }
            break
          case 'select':
            value = `0_${data.item[0].value}`
            passed = true
            if (data.item.find(x => x.price)) {
              const index = value.split('_')[0]
              const optionData = {
                id: this.data.id,
                label: data.item[index].label[lang],
                price: Number(data.item[index].price),
                ...data.optionQuantity && {
                  quantity: Number(data.item[index].quantity)
                },
                ...data.item[index].invisible && {
                  invisible: data.item[index].invisible
                }
              }
              this.$store.commit('page/priceOption', optionData)
            }
            break
          case 'datetime':
            value = {
              type: 'asap',
              settime: '',
              datetimeOnly: data.activeDate !== false && data.activeTime === false
                ? 'date'
                : data.activeDate === false && data.activeTime !== false
                  ? 'time'
                  : null
            }
            passed = true
            break
          case 'quantity':
            value = {
              value: data.value,
              price: data.price.isPrice ? regExp.uncomma(data.price.value) : null
            }
            passed = true
            break
          default:
            value = ''
        }
        if (data && data.item && !data.optionQuantity) { // 수량범위 사용 안함으로 바꿨을 때 수량 지정하던 것이 남아있음
          data.item.forEach(function (x) {
            delete x.quantity
          })
        }
        this.$store.commit('submit/submitData', storage || {
          id: this.data.id,
          name: this.data.name,
          isRequired: this.data.setting.action.isRequired === true,
          ...this.data.setting.action && {
            ...this.data.setting.action.hasSubOption && {
              subOption: this.data.setting.action.item.filter(x => x.subOption && x.subOption !== '').map(x => {
                return {
                  value: x.value,
                  subOption: x.subOption
                }
              }),
              hasSubOption: this.data.setting.action.hasSubOption
            },
            ...this.data.setting.action.isSubOption && {
              isSubOption: this.data.setting.action.isSubOption,
              parentOption: this.subOption.find(p => p.child === this.data.id).parent
            },
            ...this.data.setting.action.dataVariable && {
              dataVariable: this.data.setting.action.dataVariable
            },
            ...this.data.setting.action.disabledQty && {
              disabledQty: this.data.setting.action.disabledQty
            }
          },
          displayLabel: this.data.setting.action.label,
          label: this.data.setting.action.labelValue,
          value: value,
          passed: passed,
          ...this.data.setting.action.translate && {
            translate: this.data.setting.action.translate
          }
        })
      } else if (this.data.dataSet.column.find(x => x.detail && x.detail.upload && x.detail.upload.active)) {
        // 업로드시 전송용 데이터 세팅
        const moduleColumn = this.data.dataSet.column.filter(x => x.detail && x.detail.upload && x.detail.upload.active)
        for (let i = 0; i < moduleColumn.length; i++) {
          const column = moduleColumn[i]
          this.$store.commit('submit/submitData', {
            id: column.columnId,
            moduleId: this.data.id,
            isRequired: false,
            label: column.detail.upload.labelValue,
            displayLabel: column.detail.upload.label,
            name: 'uploadImage',
            passed: true,
            value: []
          })
        }
      }
      this.$store.commit('page/readyModule', this.data.id)
    },
    setDivisionStyle (column) {
      const divisionData = column.detail.division
      const radius = column.detail.radius && column.detail.radius.active ? column.detail.radius : null
      let styleObj = {
        'border-top-width': `${divisionData.width}px`,
        'border-top-style': divisionData.style,
        'border-top-color': divisionData.color,
        ...radius && {
          'border-radius': `${radius.tl}px ${radius.tr}px ${radius.br}px ${radius.bl}px`
        }
      }
      return styleObj
    },
    setDetailStyle (detailData) {
      const notStyles = ['options']
      const styles = Object.keys(detailData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = detailData[x]
        let key = ''
        let value = ''
        switch (x) {
          case 'background':
            if (obj.active) {
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
            } else {
              styleObj.background = '#3e3e3e'
            }
            break
          case 'border':
            if (obj.active) {
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
            } else {
              styleObj.border = 'none'
            }
            break
          case 'radius':
            if (obj.active) {
              styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
            }
            break
          case 'text':
            if (obj.active) {
              styleObj.color = obj.color
            } else {
              styleObj.color = '#ffffff'
            }
            break
        }
      })
      return styleObj
    },
    summaryOn (summaryOn) {
      this.$emit('summaryOn', summaryOn)
    },
    setPopover (id, zIndex) {
      this.$emit('setPopover', id, zIndex)
    },
    fullUrl (qr, qrExpired) {
      const siteinfo = this.siteinfo
      const win = window.location
      const expiredDay = qrExpired && qrExpired.isActive ? qrExpired.day : null
      const exp = expiredDay && Math.floor(Date.now() / 1000) + (expiredDay * 24 * 60 * 60)
      let params = publicToOta(win.search)
      let location = `${win.origin}${win.pathname}`
      const link = this.link(qr).href
      let result = ''
      // 공용디바이스 사용자는 개인링크로 변환 params
      function publicToOta (queryString) {
        const params = {}
        queryString.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
          params[key] = value
        })
        return params
      }
      if (siteinfo.public) {
        delete params.public
        if (this.publicOta) {
          params.k = this.publicOta
        }
        if (exp) {
          params.exp = exp
        }
      }
      params = Object.entries(params).map(e => e.join('=')).join('&')
      location = `${location}?${params}`
      if (qr.type === 'outlink') {
        result = link
      } else if (qr.type === 'func' || link === '' || link === '#') {
        result = '#'
      } else {
        result = `${location}${link}`
      }
      return result
    },
    isStringCode (qr) {
      const link = this.link(qr).href
      const isOutlink = qr.type === 'outlink'
      function isValidURL(url) {
        try {
          new URL(url);
          return true; // URL이 유효하면 true 반환
        } catch (_) {
          return false; // 유효하지 않으면 false 반환
        }
      }
      return isOutlink && !isValidURL(link)
    },
    uploadFile (e, columnIndex, type) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0],
        ...getFileInfo(e.target.files[0].type)
      }
      const blobToBase64 = (blob, type) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        return new Promise(resolve => {
          reader.onloadend = () => {
            resolve(reader.result)
          }
        })
      }
      function getFileInfo (typeInfo) {
        const type = typeInfo.split('/')[0]
        const format = typeInfo.split('/')[1]
        // const isValid = regExp[type] && regExp[type].test(format.toLowerCase())
        return {
          type: type,
          format: format
        }
      }
      function getFileSize (size) {
        return size / 1024 / 1024
      }
      if (data.file) {
        if (data.type) {
          if (data.type.includes('image')) {
            this.$store.dispatch('util/setImage', data).then((blob) => {
              if (blob) {
                if (getFileSize(data.file.size) > 5) {
                  // 이미지 파일은 최대 5MB까지 업로드 가능합니다.
                  alert(this.locale.alert_upload_image_size)
                } else {
                  const fileName = blob.name
                  const detailUpload = this.data.dataSet.column[columnIndex].detail.upload.files || []
                  blobToBase64(blob).then((res) => {
                    this.data.dataSet.column[columnIndex].detail.upload.files = detailUpload.concat({
                      id: data.id,
                      base64: res,
                      base64Name: res.split(',')[1],
                      name: fileName
                    })
                  })
                }
              }
            })
            // } else if (data.type.includes('video')) {
            /*
            if (window.confirm(this.locale.confirm_upload_video)) {
              if (getFileSize(data.file.size) > 20) {
                // 동영상 파일은 최대 20MB까지 업로드 가능합니다.
                alert(this.locale.alert_upload_video_size)
              } else {
                this.uploading = true
                data.cid = this.cid
                data.msgId = UNIQUE.mid()
                data.fileName = `${data.id}-${data.file.name}`
                Object.assign(data, this.user)
                this.scrollBottom()
                this.$store.dispatch('talk/resizeVideo', data).then((res) => {
                  if (res && res.status === 200) {
                    const videoData = {
                      key: data.fileName,
                      body: data.file
                    }
                    this.$store.dispatch('talk/uploadVideo', videoData).then((res) => {
                      if (!(res && res.Key && res.Location)) {
                        alert(this.locale.alert_upload_fail)
                        this.uploading = false // 업로드 응답 후 ws반응이 많이 느리기 때문에 성공시에는 add card에서 uploading 끔
                      }
                    })
                  } else {
                    alert(this.locale.alert_upload_fail)
                    this.uploading = false
                  }
                })
              }
            }
            */
          } else {
            // 지원하지 않는 형식의 파일입니다.\n이미지: png, jpeg, gif\n동영상: mp4, ogg, webm
            alert(`${this.locale.alert_upload_format_not_support}\n${this.locale.alert_upload_image_video_only}`)
          }
        } else {
          // 지원하지 않는 형식의 파일입니다.\n이미지: png, jpeg, gif\n동영상: mp4, ogg, webm
          alert(`${this.locale.alert_upload_format_not_support}\n${this.locale.alert_upload_image_video_only}`)
        }
      } else {
        alert(this.locale.alert_attach_fail)
      }
      e.target.value = ''
    },
    uploadFileActive (upload) {
      const limit = parseInt(upload.count)
      const length = parseInt(upload.files.length)
      return upload.active && length < limit
    },
    uploadFileLimit (e, upload) {
      const limit = parseInt(upload.count)
      const length = parseInt(upload.files.length)
      if (length >= limit) {
        alert(`최대 ${limit}개 까지 업로드 가능합니다.`)
        e.preventDefault()
      }
      return length >= limit
    },
    uploadFileDelete (columnIndex, fileIndex) {
      if (window.confirm('이미지 업로드를 취소하시겠습니까?')) {
        this.data.dataSet.column[columnIndex].detail.upload.files = this.data.dataSet.column[columnIndex].detail.upload.files.filter((x, i) => i !== fileIndex)
      }
    }
  }
}
</script>
